// Centralized access control configuration
// Define which users (by userId) can see which UI blocks / menu items.
// Keys should match either:
// - "configurationTopbar" for the topbar Config button
// - linkKey values from the main menu (e.g., 'menu_reports', 'menu_ai')
const jefaturaIds = [
  1, 15, 72, 28, 204, 205, 207, 408, 984, 837, 444, 142, 19, 55, 67, 142, 143,
  157, 187, 610, 619, 710, 802, 808, 436, 994, 995, 1013, 1086, 922, 110, 641,
  520, 114,
];
const developersIds = [1, 1084, 1111];
export const configurationRoleBlock = {
  // Topbar configuration
  // configurationTopbar: {
  //   allowedUserIds: jefaturaIds,
  // },

  // Calendar user selector
  calendarUserSelector: {
    allowedUserIds: jefaturaIds,
  },

  // "Mensajeria"
  // menu_messaging: {
  //   allowedUserIds: jefaturaIds,
  // },
  // "Scoring Abogados"
  // menu_lawyerScoring: {
  //   allowedUserIds: jefaturaIds,
  // },
  // "Uso Plantillas"
  // menu_docUsage: {
  //   allowedUserIds: jefaturaIds,
  // },
  // "Inteligencia Artificial"
  // menu_ai: {
  //   allowedUserIds: jefaturaIds,
  // },

  clientDetailBypass: {
    // Permite ver ficha de cliente aunque esté en baja/bloqueado
    allowedUserIds: jefaturaIds,
  },

  clientActiveToggle: {
    // Permite activar/inactivar clientes desde la ficha
    allowedUserIds: jefaturaIds,
  },

  caseDetailBypass: {
    // Permite ver ficha de causa aunque el cliente esté en baja/bloqueado
    allowedUserIds: jefaturaIds,
  },

  developersUsers: {
    // Usuarios exentos de advertencias de ambiente
    allowedUserIds: developersIds,
  },

  scheduleAllSelector: {
    allowedUserIds: jefaturaIds,
  },
};
